import * as React from "react"
import {useSignal} from "@preact/signals-react";
import {ButtonIconSeeker} from "@ui-seeker/core";


export default function ExcelButton({ onClick }) {
    const isDownloading = useSignal(false)

    return <ButtonIconSeeker
        icon={isDownloading.value ? 'spinner-third' : 'arrow-down-to-line'}
        iconProps={{ isSpin: isDownloading.value }}
        onClick={() => {
            isDownloading.value = true
            try {
                onClick().finally(() => isDownloading.value = false)
            } catch (e) {
                console.error(e)
                if (e instanceof TypeError && e.message === "Cannot read properties of undefined (reading 'finally')")
                    isDownloading.value = false
                else throw e
            }
        }}
        tooltip="Download Excel"
    />
}